import { useQueryClient } from "@tanstack/react-query";
import { $api } from "../generated/client";
import { useApiMutation } from "./use-api-mutation";

const secretQueryKey = (shopId: string) => [
	"get",
	"/shops/{shopId}/outgoing-webhooks/secret",
	{ params: { path: { shopId } } },
];

/** Admin-only: the route answers 403 to the other members. */
export default function useOutgoingWebhookSecret(
	shopId: string,
	{ enabled = true }: { enabled?: boolean } = {},
) {
	return $api.useQuery(
		"get",
		"/shops/{shopId}/outgoing-webhooks/secret",
		{ params: { path: { shopId } } },
		{ enabled },
	);
}

export function useRegenerateOutgoingWebhookSecret(shopId: string) {
	const queryClient = useQueryClient();

	return useApiMutation<
		"post",
		"/shops/{shopId}/outgoing-webhooks/secret/regenerate",
		void
	>("post", "/shops/{shopId}/outgoing-webhooks/secret/regenerate", {
		mapVariables: () => ({ params: { path: { shopId } } }),
		onSuccess: (data) => {
			queryClient.setQueryData(secretQueryKey(shopId), data);
		},
	});
}
